import styled from "styled-components";

export { Container, StepTitle } from '../StepOne/styles';

export const ProposalDetails = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto 30px auto;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
`;

export const Footer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const DetailItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 16px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  strong {
    color: #333;
    font-weight: 600;
  }

  span {
    color: #555;
    text-align: right;
  }
`;

export const DocumentLinkButton = styled.button`
  display: inline-block;
  margin: 0 auto 30px auto;
  padding: 10px 20px;
  background-color: #e8e8e8;
  color: #333;
  text-decoration: none;
  border-radius: 5px;
  font-weight: 600;
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #dcdcdc;
  }
`;

export const DocumentViewer = styled.div`
  width: 100%;
  max-width: 800px;
  height: 70vh;
  margin: 30px auto;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;

  iframe {
    width: 100%;
    height: 100%;
  }
`;

export const AcceptanceText = styled.p`
  font-size: 12px;
  color: #888;
  margin-top: 15px;
  max-width: 350px;
  line-height: 1.5;
  text-align: center;
  display: inline-block;
`;
